import React, { useState, useEffect } from 'react';
import TechStack from './TechStack';
import { db, isConfigured } from '../firebaseConfig';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';

function Services() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    if (!isConfigured) {
      console.log('Firebase not configured, using default services');
      setServices(getDefaultServices());
      setLoading(false);
      return;
    }

    try {
      console.log('📊 Fetching services from Firebase...');
      const q = query(collection(db, 'services'), orderBy('createdAt', 'asc'));
      const querySnapshot = await getDocs(q);
      
      console.log(`✅ Found ${querySnapshot.size} services`);
      
      const servicesList = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      if (servicesList.length > 0) {
        setServices(servicesList);
      } else {
        // Use default services if none in database
        setServices(getDefaultServices());
      }
    } catch (error) {
      console.error('Error fetching services:', error);
      setServices(getDefaultServices());
    } finally {
      setLoading(false);
    }
  };

  const getDefaultServices = () => [
    {
      title: 'Web Development',
      description: 'From responsive websites to dynamic web applications, I build powerful digital solutions using the latest technologies. My web development service ensures fast load times, secure coding, and clean, maintainable architecture.'
    },
    {
      title: 'App Development',
      description: 'I create user-friendly, high-performance mobile apps tailored for Android and iOS platforms. My solutions are built to scale, offering seamless functionality, speed, and intuitive user experiences that keep the users engaged.'
    },
    {
      title: 'UI/UX Design',
      description: 'I design interfaces that are not only beautiful but also functional. My UI/UX expertise focuses on user behavior and accessibility to deliver designs that enhance user engagement and satisfaction across all devices.'
    }
  ];

  const scrollToProjects = () => {
    const element = document.getElementById('projects');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  if (loading) {
    return (
      <div className="min-h-[50vh] flex items-center justify-center">
        <div className="text-white text-xl">Loading services...</div>
      </div>
    );
  }

  return (
    <div className="min-h-[50vh] flex flex-col lg:flex-col items-center justify-center gap-8 sm:gap-12 lg:gap-16 px-4 sm:px-6 lg:px-8 py-8" id="services">
      <h2 className='text-white font-bold text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-center'>
        SERVICES
      </h2>
      
      <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-4 w-full max-w-6xl'>
        {services.map((service, index) => (
          <div 
            key={service.id || index}
            className={`px-4 py-4 bg-white text-gray-800 rounded-xl transition-all duration-300 hover:scale-105 shadow-lg ${
              index === 1 ? 'sm:col-span-1 lg:col-span-1 ml-8 sm:ml-8 lg:ml-0 lg:-translate-y-4' : ''
            }`}
          >
            <h2 className='font-bold text-lg sm:text-xl mb-3 text-[#FFB7CE]'>
              {service.title}
            </h2>
            <p className='text-sm sm:text-base leading-relaxed mb-4 text-gray-700'>
              {service.description}
            </p>
            <button 
              onClick={scrollToProjects} 
              className='w-fit px-6 py-3 bg-[#89CFF0] text-white rounded-xl hover:bg-[#6BB8E0] transition-colors duration-200 text-sm sm:text-base font-medium'
            >
              View my Projects
            </button>
          </div>
        ))}
      </div>
      
      <TechStack/>
    </div>
  );
}

export default Services;